import React, { useCallback, useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import './AccountError.scss'
import { loginRoutes, routes } from '@constants/routes.const'
import { Header } from '@components/Header/Header'
import { SecondaryButton } from '@components/Buttons/SecondaryButton/SecondaryButton'
import Text from '@components/Text/Text'
import { TextTag } from '@enums/textTag'
import { VelvetSDK } from 'sdk'

interface AccountErrorProps {
  showMenu: (status: boolean) => void
}

export const AccountError = ({ showMenu }: AccountErrorProps) => {
  const tryAgainButtonRef = useRef<HTMLButtonElement>(null)
  const navigate = useNavigate()
  const V = VelvetSDK.Vocabulary.vocabulary

  const tryAgainClicked = useCallback(() => {
    navigate(routes.LOGIN)
  }, [navigate])

  const navigateToForgotPassword = useCallback(() => {
    navigate(`${routes.LOGIN}/${loginRoutes.FORGOT_PASSWORD}`)
  }, [navigate])

  useEffect(() => {
    showMenu(false)
    tryAgainButtonRef?.current?.focus()

    return () => {
      showMenu(true)
    }
  }, [tryAgainButtonRef, showMenu])

  return (
    <div className="account-error">
      <Header label="LogIn" />
      <div className="account-error">
        <div className="account-error__text">
          <Text tag={TextTag.P}>{V?.loginProblemAccount}</Text>
          <Text tag={TextTag.P}>{V?.loginWrongEmailPassword}</Text>
        </div>
        <div className="account-error__button-container">
          <SecondaryButton onClick={tryAgainClicked} buttonRef={tryAgainButtonRef}>
            {V?.loginTryAgain}
          </SecondaryButton>
          <SecondaryButton onClick={navigateToForgotPassword}>{V?.loginForgotPassword}</SecondaryButton>
        </div>
      </div>
    </div>
  )
}
